import React from 'react';
import { t } from 'i18next';
import { CHECKED, UNCHECKED } from 'icons';

const SubOption = ({ subOption, isSelected, onToggle }) => {
    return (
        <li className="flex items-center gap-2" onClick={onToggle}>
            <span className="w-5 h-5 inline-flex">
                {isSelected ? <CHECKED /> : <UNCHECKED />}
            </span>
            <span className={isSelected ? "font-bold text-16x drop-shadow-sm" : "text-16x drop-shadow-sm"}>
                {subOption?.symbol} {t(subOption?.label)}
            </span>
        </li>
    );
};

export default SubOption;
